export default {
    closeIcon: {
        position: "absolute",
        right: 8,
        top: 8
    }
};
